import { YouTubePlayerModule } from '@angular/youtube-player';
import { RouterModule } from '@angular/router';
import { TeacherCacheStatusComponent } from './teacher-cache-status/teacher-cache-status.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterListComponent } from './filter-list/filter-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Radar2Component } from './radar2/radar2.component';
import { MaterialModule } from '../material.module';
import { NgChartsModule } from 'ng2-charts';
import { TimelineComponent } from './timeline/timeline.component';
import { MomentModule } from 'ngx-moment';
import { LogoutComponent } from './logout/logout.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { LevelComponent } from './level/level.component';
import { RadarComponent } from './radar/radar.component';
import { DirectiveModule } from '../directive/directive.module';
import { DatatableComponent } from './datatable/datatable.component';
import { DatatableCellStudentComponent } from './datatable/datatable-cell-student/datatable-cell-student.component';
import { DatatableCellStudentEmailComponent } from './datatable/datatable-cell-student-email/datatable-cell-student-email.component';
import { DatatableCellStudentBirthdateComponent } from './datatable/datatable-cell-student-birthdate/datatable-cell-student-birthdate.component';
import { DatatableCellTeacherComponent } from './datatable/datatable-cell-teacher/datatable-cell-teacher.component';
import { DatatableCellSiteComponent } from './datatable/datatable-cell-site/datatable-cell-site.component';
import { DatatableCellTeachersComponent } from './datatable/datatable-cell-teachers/datatable-cell-teachers.component';
import { DatatableCellSitesComponent } from './datatable/datatable-cell-sites/datatable-cell-sites.component';
import { DatatableCellFormationComponent } from './datatable/datatable-cell-formation/datatable-cell-formation.component';
import { DatatableCellDateRangeComponent } from './datatable/datatable-cell-date-range/datatable-cell-date-range.component';
import { DatatableCellLanguageComponent } from './datatable/datatable-cell-language/datatable-cell-language.component';
import { DatatableCellLanguagesComponent } from './datatable/datatable-cell-languages/datatable-cell-languages.component';
import { DatatableCellUserComponent } from './datatable/datatable-cell-user/datatable-cell-user.component';
import { DatatableCellNextOccurrenceComponent } from './datatable/datatable-cell-next-occurrence/datatable-cell-next-occurrence.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ChatComponent } from './chat/chat.component';
import { TranslateModule } from '@ngx-translate/core';
import { LilateProgressionComponent } from './lilate-progression/lilate-progression.component';
import { RadarLilateComponent } from './radar-lilate/radar-lilate.component';
import { TimezoneAutocompleteComponent } from './timezone-autocomplete/timezone-autocomplete.component';
import { TimeSelectorNoDispoComponent } from './time-selector-no-dispo/time-selector-no-dispo.component';
import { SheetAssignComponent } from './sheet-assign/sheet-assign.component';
import { SheetAssignedComponent } from './sheet-assigned/sheet-assigned.component';
import { SheetViewComponent } from './sheet-view/sheet-view.component';
import { SheetExercicesComponent } from './sheet-exercices/sheet-exercices.component';
import { SheetExerciceQcmComponent } from './sheet-exercices/sheet-exercice-qcm/sheet-exercice-qcm.component';
import { SheetExercicesBilanComponent } from './sheet-exercices-bilan/sheet-exercices-bilan.component';
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { TeacherProfilComponent } from './teacher-profil/teacher-profil.component';
import { ModalComponent } from './modal/modal.component';
import { StudentFeedbackComponent } from './student-feedback/student-feedback.component';
import { PonctualScheduleComponent } from './ponctual-schedule/ponctual-schedule.component';
import { RecScheduleComponent } from './rec-schedule/rec-schedule.component';
import { CarouselComponent } from './carousel/carousel.component';
import { RadioAvailabilitiesComponent } from './radio-availabilities/radio-availabilities.component';
import { WebcamComponent } from './webcam/webcam.component';
import { NextSessionComponent } from './next-session/next-session.component';
import { ComprateComponent } from './comprate/comprate.component';
import { LilateComponent } from './lilate/lilate.component';
import { ValidateSheetComponent } from './validate-sheet/validate-sheet.component';
import { SheetPracticeComponent } from './sheet-practice/sheet-practice.component';
import { SheetRelatedComponent } from './sheet-related/sheet-related.component';
import { DashboardTeacherNotificationComponent } from './dashboard-teacher/dashboard-teacher-notification/dashboard-teacher-notification.component';
import { DashboardTeacherNextSessionComponent } from './dashboard-teacher/dashboard-teacher-next-session/dashboard-teacher-next-session.component';
import { DashboardTeacherBillingComponent } from './dashboard-teacher/dashboard-teacher-billing/dashboard-teacher-billing.component';
import { NextSessionAllFormationsComponent } from './next-session-all-formations/next-session-all-formations.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { AchievementModalComponent } from './achievement-modal/achievement-modal.component';
import { CancelLilateComponent } from './cancel-lilate/cancel-lilate.component';
import { IdentityCheckComponent } from './identity-check/identity-check.component';
import { TimeslotComponent } from '../directive/timeslot/timeslot.component';
import { ModalEvent } from './modal-event/modal-event';
import { DatatablePhotoStatusComponent } from './datatable/datatable-cell-photo-status/datatable-photo-status.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FeedbackComponent } from './feedback/feedback.component';
import { CreateUserDialogComponent } from './create-user-dialog/create-user-dialog.component';
import { CreateCompanyDialogComponent } from './create-company-dialog/create-company-dialog.component';
import { AddTeacherDiplomaDialogComponent } from './add-teacher-diploma-dialog/add-teacher-diploma-dialog.component';
import { ImageCropperPreviewComponent } from './image-cropper-preview/image-cropper-preview.component';
import { BirthdateInputComponent } from './birthdate-input/birthdate-input.component';
import { BirthdateFormComponent } from './birthdate-form/birthdate-form.component';
import { GenderInputComponent } from './gender-input/gender-input.component';
import { JobFormComponent } from './job-form/job-form.component';
import { JobFormStaffComponent } from './job-form/job-form-staff/job-form-staff.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { LanguagesTranslateComponent } from './languages-translate/languages-translate.component';
import { LilateCardRecComponent } from './lilate-card-rec/lilate-card-rec.component';
import { LilateCardDoneRecComponent } from './lilate-card-rec/lilate-card-done-rec/lilate-card-done-rec.component';
import { LilateCardBookedRecComponent } from './lilate-card-rec/lilate-card-booked-rec/lilate-card-booked-rec.component';
import { LilateCardIdentityIssueRecComponent } from './lilate-card-rec/lilate-card-identity-issue-rec/lilate-card-identity-issue-rec.component';
import { LilateCardPendingBookingRecComponent } from './lilate-card-rec/lilate-card-pending-booking/lilate-card-pending-booking-rec.component';
import { LilateCardPendingAssessmentRecComponent } from './lilate-card-rec/lilate-card-pending-assessment-rec/lilate-card-pending-assessment-rec.component';
import { LilateCardCancelledByTeacherRecComponent } from './lilate-card-rec/lilate-card-cancelled-by-teacher-rec/lilate-card-cancelled-by-teacher-rec.component';
import { PollFormStudentComponent } from './poll-form-student/poll-form-student.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ExerciceAssignComponent } from './exercice-assign/exercice-assign.component';
import { CreateExerciceComponent } from './create-exercice/create-exercice.component';
import { ExerciceAssignedComponent } from './exercice-assigned/exercice-assigned.component';
import { ExerciceViewComponent } from './exercice-view/exercice-view.component';
import { ExercicesInfosComponent } from './exercices-infos/exercices-infos.component';
import { ProgressGaugeComponent } from './progress-gauge/progress-gauge.component';
import { TaskToDoComponent } from './task-to-do/task-to-do.component';
import { TaskDoneComponent } from './task-done/task-done.component';
import { ExerciceModalComponent } from './task-to-do/exercice-modal/exercice-modal.component';
import { ContentEditorComponent } from './content-editor/content-editor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ExercicesInfoTeacherGaugeComponent } from './exercices-info-teacher-gauge/exercices-info-teacher-gauge.component';
import { ToHourMinutePipe } from '../pipe/to-hour-minute.pipe';
import { TargetedLevelSelectionComponent } from './targeted-level-selection/targeted-level-selection.component';
import { ExercicePreviewComponent } from './exercice-preview/exercice-preview.component';

@NgModule({
  imports: [
    MaterialModule,
    NgChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    CommonModule,
    RouterModule,
    DirectiveModule,
    InfiniteScrollModule,
    TranslateModule.forChild(),
    YouTubePlayerModule,
    ImageCropperComponent,
    CKEditorModule
  ],
  declarations: [
    PageNotFoundComponent,
    LoginComponent,
    FilterListComponent,
    Radar2Component,
    RadarLilateComponent,
    TimelineComponent,
    LogoutComponent,
    ResetPasswordComponent,
    SearchBarComponent,
    LevelComponent,
    TargetedLevelSelectionComponent,
    // DocumentItemComponent
    DatatableComponent,
    DatatableCellStudentComponent,
    DatatableCellStudentEmailComponent,
    DatatableCellStudentBirthdateComponent,
    DatatableCellTeacherComponent,
    DatatableCellSiteComponent,
    DatatableCellTeachersComponent,
    DatatableCellSitesComponent,
    DatatableCellFormationComponent,
    DatatableCellDateRangeComponent,
    DatatableCellLanguageComponent,
    DatatableCellUserComponent,
    DatatableCellNextOccurrenceComponent,
    DatatableCellLanguagesComponent,
    DatatablePhotoStatusComponent,
    RadarComponent,
    ChatComponent,
    LilateProgressionComponent,
    TimezoneAutocompleteComponent,
    ConfirmationDialogComponent,
    TimeSelectorNoDispoComponent,
    TeacherCacheStatusComponent,
    SheetAssignComponent,
    SheetAssignedComponent,
    SheetViewComponent,
    SheetExercicesComponent,
    SheetExerciceQcmComponent,
    SheetExercicesBilanComponent,
    LostPasswordComponent,
    TeacherProfilComponent,
    ModalComponent,
    StudentFeedbackComponent,
    PonctualScheduleComponent,
    RecScheduleComponent,
    CarouselComponent,
    RadioAvailabilitiesComponent,
    WebcamComponent,
    NextSessionComponent,
    ComprateComponent,
    LilateComponent,
    ValidateSheetComponent,
    SheetPracticeComponent,
    SheetRelatedComponent,
    DashboardTeacherNotificationComponent,
    DashboardTeacherNextSessionComponent,
    DashboardTeacherBillingComponent,
    NextSessionAllFormationsComponent,
    MaintenanceComponent,
    TooltipComponent,
    AchievementModalComponent,
    CancelLilateComponent,
    IdentityCheckComponent,
    TimeslotComponent,
    ModalEvent,
    FeedbackComponent,
    CreateUserDialogComponent,
    CreateCompanyDialogComponent,
    AddTeacherDiplomaDialogComponent,
    ImageCropperPreviewComponent,
    BirthdateInputComponent,
    BirthdateFormComponent,
    GenderInputComponent,
    JobFormComponent,
    JobFormStaffComponent,
    CreatePasswordComponent,
    LanguagesTranslateComponent,
    LilateCardRecComponent,
    LilateCardDoneRecComponent,
    LilateCardBookedRecComponent,
    LilateCardIdentityIssueRecComponent,
    LilateCardPendingBookingRecComponent,
    LilateCardPendingAssessmentRecComponent,
    LilateCardCancelledByTeacherRecComponent,
    PollFormStudentComponent,
    ExerciceAssignComponent,
    CreateExerciceComponent,
    ExerciceAssignedComponent,
    ExerciceViewComponent,
    ExercicesInfosComponent,
    ProgressGaugeComponent,
    TaskToDoComponent,
    TaskDoneComponent,
    ExerciceModalComponent,
    ContentEditorComponent,
  ExercicesInfoTeacherGaugeComponent,
  ToHourMinutePipe,
  ExercicePreviewComponent
  ],
  exports: [
    NgChartsModule,
    FilterListComponent,
    LilateProgressionComponent,
    RadarComponent,
    Radar2Component,
    RadarLilateComponent,
    LoginComponent,
    LogoutComponent,
    ResetPasswordComponent,
    SearchBarComponent,
    LevelComponent,
    DatatableComponent,
    PageNotFoundComponent,
    TimezoneAutocompleteComponent,
    ConfirmationDialogComponent,
    InfiniteScrollModule,
    TimeSelectorNoDispoComponent,
    TeacherCacheStatusComponent,
    SheetAssignComponent,
    SheetAssignedComponent,
    SheetViewComponent,
    SheetExercicesComponent,
    SheetExerciceQcmComponent,
    SheetExercicesBilanComponent,
    TeacherProfilComponent,
    ModalComponent,
    StudentFeedbackComponent,
    PonctualScheduleComponent,
    RecScheduleComponent,
    CarouselComponent,
    WebcamComponent,
    NextSessionComponent,
    ComprateComponent,
    LilateComponent,
    ValidateSheetComponent,
    SheetPracticeComponent,
    SheetRelatedComponent,
    DashboardTeacherNotificationComponent,
    DashboardTeacherNextSessionComponent,
    DashboardTeacherBillingComponent,
    NextSessionAllFormationsComponent,
    DatatableCellStudentComponent,
    DatatableCellSiteComponent,
    DatatableCellStudentEmailComponent,
    DatatableCellStudentBirthdateComponent,
    DatatableCellTeacherComponent,
    DatatableCellFormationComponent,
    TooltipComponent,
    AchievementModalComponent,
    CancelLilateComponent,
    IdentityCheckComponent,
    TimeslotComponent,
    ModalEvent,
    CreateUserDialogComponent,
    CreateCompanyDialogComponent,
    AddTeacherDiplomaDialogComponent,
    ImageCropperPreviewComponent,
    BirthdateInputComponent,
    BirthdateFormComponent,
    GenderInputComponent,
    JobFormComponent,
    JobFormStaffComponent,
    CreatePasswordComponent,
    LanguagesTranslateComponent,
    LilateCardRecComponent,
    LilateCardDoneRecComponent,
    LilateCardBookedRecComponent,
    LilateCardIdentityIssueRecComponent,
    LilateCardPendingBookingRecComponent,
    LilateCardPendingAssessmentRecComponent,
    LilateCardCancelledByTeacherRecComponent,
    PollFormStudentComponent,
    ExerciceAssignComponent,
    CreateExerciceComponent,
    ExerciceAssignedComponent,
    ExerciceViewComponent,
    ExercicesInfosComponent,
    ProgressGaugeComponent,
    TaskToDoComponent,
    TaskDoneComponent,
    ContentEditorComponent,
  ExercicesInfoTeacherGaugeComponent,
  ToHourMinutePipe,
  TargetedLevelSelectionComponent,
  ExercicePreviewComponent
  ]
})
export class FeatureModule { }
